"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _dayjs = _interopRequireDefault(require("dayjs"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var addHours = function addHours(date, hours) {
  return (0, _dayjs["default"])(date).add(hours, 'hour').toISOString();
};

var _default = addHours;
exports["default"] = _default;